import { render, staticRenderFns } from "./DimensionBoostModal.vue?vue&type=template&id=7ee1ffcf&"
import script from "./DimensionBoostModal.vue?vue&type=script&lang=js&"
export * from "./DimensionBoostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports